import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { getRouteApi } from '@tanstack/react-router'

import { cn } from '@gto/ui/cn'
import { Typography } from '@gto/ui/typography'

import { getBackUrl } from '@/utils/helpers'

const routeApi = getRouteApi('/_auth/login/verify-email/code')

export const RootRoute = () => {
  const navigate = routeApi.useNavigate()
  const search = routeApi.useSearch()
  const { status } = routeApi.useLoaderData()
  const [counter, setCounter] = useState(5)

  useEffect(function countDownVerificationCode() {
    const timer = setInterval(() => {
      setCounter((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
        }

        return prev - 1
      })
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  useEffect(
    function redirectAfterCountdown() {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler -- timer-driven navigation, not a user event: the sibling setInterval drives `counter` to 0 and this redirects to /login. The trigger is elapsed time, so there is no handler to move it into. Folding the navigate into the interval tick would run a router side effect from inside a setState updater (illegal); keeping the timer as the state source and reacting to counter===0 here is the correct split.
      if (counter === 0) {
        navigate({
          to: '/login',
          search: {
            back_url: getBackUrl(search.back_url),
            type: 'implicit',
          },
          viewTransition: true,
          replace: true,
        }).catch(console.error)
      }
    },
    [counter, navigate, search.back_url],
  )

  const isError = status === 'error'

  return (
    <div
      className={cn(
        'fixed left-0 right-0 top-0 p-3 text-center',
        isError ? 'bg-error-main' : 'bg-gradient-primary-horizontal',
      )}
    >
      <Typography
        className="font-medium"
        color={isError ? 'error.contrastText' : 'primary'}
        variant="body2"
      >
        <FormattedMessage
          id={isError ? 'auth.emailValidation.code.failed' : 'auth.emailValidation.code.success'}
        />
        <FormattedMessage
          id="auth.emailValidation.code.redirect"
          values={{ counter }}
        />
      </Typography>
    </div>
  )
}
